import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Upload = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M2.5 13.333a1.25 1.25 0 1 0-2.5 0V17.5c0 .69.56 1.25 1.25 1.25h17.5c.69 0 1.25-.56 1.25-1.25v-4.167a1.25 1.25 0 1 0-2.5 0v2.917h-15z" }), _jsx("path", { d: "M14.375 8.152c.327 0 .641-.128.875-.357.5-.563.5-1.313 0-1.813l-4.375-4.375a1.25 1.25 0 0 0-1.75 0L4.75 5.982A1.26 1.26 0 0 0 6.5 7.795l2.25-2.25v7.625a1.25 1.25 0 0 0 2.5 0V5.545l2.25 2.25c.234.229.548.357.875.357" })] }));
});
Upload.displayName = 'Upload';
Upload.__iconComponentType = 'standard';
export default Upload;
//# sourceMappingURL=Upload.js.map